import { render } from "./certificate-verify.vue?vue&type=template&id=37511b21&scoped=true"
import script from "./certificate-verify.vue?vue&type=script&lang=js"
export * from "./certificate-verify.vue?vue&type=script&lang=js"

import "./certificate-verify.vue?vue&type=style&index=0&id=37511b21&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37511b21"]])

export default __exports__